import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { includeChildrenOnSearch } from 'app/area/list-view-code-selector/constants';

export const getOptions = (searchInput: string, options: CodeComplexValue<number>[]) =>
  !shouldDisplaySingleFlexibleColumn(searchInput)
    ? options
    : filterOptionsBySearchInput(searchInput, options, [])
      ?.filter(filterFoldersOut)
      ?.map(mapOptionToFlatOption);

export const shouldDisplaySingleFlexibleColumn = (searchInput: string) => searchInput !== '' && searchInput !== undefined;

const filterOptionsBySearchInput = (searchInput: string, options: CodeComplexValue<number>[], resultOptions: CodeComplexValue<number>[],
  path: CodeComplexValue<number>[] = []): CodeComplexValue<number>[] => {
  if (!options || options.length === 0) {
    return resultOptions;
  }

  return options.reduce((resultOptionsInternal, option) => hasDescendants(option)
    ? findOptionsInDescendants(searchInput, option, resultOptionsInternal, path)
    : findInOption(searchInput, option, resultOptionsInternal, path), resultOptions);
};

const hasDescendants = (option: CodeComplexValue<number>) => !!option.descendants && option.descendants.length > 0;

const mapOptionToFlatOption = (option: CodeComplexValue<number>): CodeComplexValue<number> => ({
  ...option, descendants: undefined
});

const findOptionsInDescendants = (searchInput: string, option: CodeComplexValue<number>, resultOptions: CodeComplexValue<number>[],
  path: CodeComplexValue<number>[]): CodeComplexValue<number>[] => includeChildrenOnSearch && includesSearchedPhrase(searchInput, option)
    ? [...resultOptions, ...option.descendants.map(descendant => ({ ...descendant, fullPath: [...path, mapOptionToFlatOption(option)] }))]
    : filterOptionsBySearchInput(searchInput, option.descendants, resultOptions, [...path, option]);

const includeOptionInResult = (resultOptions: CodeComplexValue<number>[],
  option: CodeComplexValue<number>, path: CodeComplexValue<number>[]): CodeComplexValue<number>[] =>
  [...resultOptions, { ...option, fullPath: path.map(pathItem => mapOptionToFlatOption(pathItem)) }];

const findInOption = (searchInput: string, option: CodeComplexValue<number>, resultOptions: CodeComplexValue<number>[],
  path: CodeComplexValue<number>[]): CodeComplexValue<number>[] => includesSearchedPhrase(searchInput, option)
    ? includeOptionInResult(resultOptions, option, path)
    : resultOptions;

const includesSearchedPhrase = (searchInput: string, option: CodeComplexValue<number>) =>
  extractSearchPhraseWords(searchInput?.toLowerCase())?.every(word => option.description?.toLowerCase()?.includes(word));

const extractSearchPhraseWords = (searchInput: string): string[] => searchInput.split(' ');

const filterFoldersOut = (option: CodeComplexValue<number>): boolean => !option.descendants || option.descendants.length === 0;
